import React, { useEffect, useState } from 'react'
import './loader.css'
import logo from '../../../Images/logo.png'
const Loader = () => {
 const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length < 3 ? prev + '.' : ''));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="advanced-loader-overlay">
      <div className="advanced-loader-container">
        <img src={logo} alt="Do More Loading" className="advanced-loader-logo" />
        <div className="loading-text">Loading{dots}</div>
      </div>
    </div>
  );
};

export default Loader
